import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';

export default function StepAdminRecinto({ datos, onNext }) {
  const [form, setForm] = useState({
    nombre:   datos.nombre   || '',
    email:    datos.email    || '',
    celular:  datos.celular  || '',
    password: datos.password || '',
    confirmar: '',
  });
  const [errores,   setErrores]   = useState({});
  const [validando, setValidando] = useState(false);

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErrores(prev => ({ ...prev, [campo]: '' }));
  };

  const handleNext = async () => {
    // Validaciones locales
    const e = {};
    if (!form.nombre.trim())               e.nombre    = 'Ingresa tu nombre';
    if (!form.email.includes('@'))         e.email     = 'Email invalido';
    if (!form.celular || form.celular.length < 8) e.celular = 'Celular invalido';
    if (form.password.length < 6)          e.password  = 'Minimo 6 caracteres';
    if (form.password !== form.confirmar)  e.confirmar = 'Las contraseñas no coinciden';

    if (Object.keys(e).length > 0) { setErrores(e); return; }

    // Validar email en backend ANTES de avanzar
    setValidando(true);
    try {
      const res  = await fetch(`${API}/api/usuarios/verificar-email?email=${encodeURIComponent(form.email)}`);
      const data = await res.json();
      if (data.existe) {
        setErrores({ email: 'Este email ya está registrado en TuRival' });
        setValidando(false);
        return;
      }
    } catch (err) {
      // Si falla la verificación, igual avanzar
    }
    setValidando(false);

    const { confirmar, ...datosLimpios } = form;
    onNext(datosLimpios);
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Cuenta del administrador</h2>
      <p style={styles.sub}>
        Esta es tu cuenta personal para gestionar el recinto en TuRival.
      </p>

      {[
        { campo: 'nombre',    label: 'Nombre completo',       placeholder: 'Juan Pérez',          type: 'text'     },
        { campo: 'email',     label: 'Email',                  placeholder: 'juan@recinto.cl',     type: 'email'    },
        { campo: 'celular',   label: 'Celular',                placeholder: '+56 9 1234 5678',     type: 'text'     },
        { campo: 'password',  label: 'Contraseña',             placeholder: 'Mínimo 6 caracteres', type: 'password' },
        { campo: 'confirmar', label: 'Confirmar contraseña',   placeholder: 'Repite tu contraseña', type: 'password' },
      ].map(({ campo, label, placeholder, type }) => (
        <div key={campo} style={styles.campo}>
          <label style={styles.label}>{label.toUpperCase()}</label>
          <input
            type={type}
            value={form[campo]}
            onChange={e => actualizar(campo, e.target.value)}
            placeholder={placeholder}
            style={{
              ...styles.input,
              borderColor: errores[campo] ? '#EF4444' : '#E8ECF4',
            }}
          />
          {errores[campo] && (
            <span style={styles.error}>{errores[campo]}</span>
          )}
        </div>
      ))}

      <button
        style={{ ...styles.btnNext, opacity: validando ? 0.6 : 1 }}
        onClick={handleNext}
        disabled={validando}
      >
        {validando ? 'Verificando...' : 'Siguiente →'}
      </button>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5,
  },
  campo: { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  error: {
    display: 'block', fontSize: 11,
    color: '#EF4444', marginTop: 4,
    fontFamily: "'Barlow', sans-serif",
  },
  btnNext: {
    width: '100%', padding: '13px',
    background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer',
    marginTop: 8,
  },
};
